import { createGlobalStyle } from 'styled-components';

import GillSansLight from '../fonts/GillSans-Light.ttf';
import GillSansBold from '../fonts/GillSans-Bold.otf';
import GillSansHeavy from '../fonts/GillSans-Heavy.otf';

export default createGlobalStyle`
  @font-face {
    font-family: 'Gill Sans';
    src: url(${GillSansLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gill Sans';
    src: url(${GillSansBold}) format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gill Sans';
    src: url(${GillSansHeavy}) format('opentype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    height: 100%;
    font-family: ${({ theme }) => theme.typography.body};
    background: ${({ theme }) => theme.colors.bgColor};
    color: ${({ theme }) => theme.colors.text.dark.very};
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body,
  input,
  button {
    font: 14px ${({ theme }) => theme.typography.body};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.typography.heading};
    color: ${({ theme }) => theme.colors.text.dark.very};
  }

  *:focus {
    outline: 0;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.main};

    &:hover {
      color: ${({ theme }) => theme.colors.primary.light};
    }
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }
`;
